export var ShareTone;
(function (ShareTone) {
    ShareTone["Neutral"] = "NEUTRAL";
    ShareTone["Playful"] = "PLAYFUL";
})(ShareTone || (ShareTone = {}));
//# sourceMappingURL=share-tone.enum.js.map